module.exports = __webpack_public_path__ + "static/media/h3.a4a9934a.svg";